import { conversation } from 'services';
import { API_CONVERSATION_FEEDBACKS } from 'utils/constants';

const getAllFeedbackService = () => {
  return conversation.get(API_CONVERSATION_FEEDBACKS);
};

export { getAllFeedbackService };
